'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFavList = exports.isValidListItem = exports.getItemRef = exports.isActionEnded = exports.isListItem = exports.validStatusOpts = exports.isCollectionList = exports.validSortOpts = undefined;

var _eq2 = require('lodash/fp/eq');

var _eq3 = _interopRequireDefault(_eq2);

var _partialRight2 = require('lodash/partialRight');

var _partialRight3 = _interopRequireDefault(_partialRight2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _overEvery2 = require('lodash/overEvery');

var _overEvery3 = _interopRequireDefault(_overEvery2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

var _matchesProperty2 = require('lodash/matchesProperty');

var _matchesProperty3 = _interopRequireDefault(_matchesProperty2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isNumber2 = require('lodash/isNumber');

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _includes2 = require('lodash/includes');

var _includes3 = _interopRequireDefault(_includes2);

var _conforms2 = require('lodash/conforms');

var _conforms3 = _interopRequireDefault(_conforms2);

var _ary2 = require('lodash/ary');

var _ary3 = _interopRequireDefault(_ary2);

var _reduxGraph = require('redux-graph');

var _const = require('./const');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { entityHasType } from 'redux-graph'
var validSortOpts = exports.validSortOpts = (0, _partial3.default)(_includes3.default, [_const.ASC, _const.DESC]);
var isCollectionList = exports.isCollectionList = (0, _conforms3.default)({
  dateCreated: _isNumber3.default,
  id: _isString3.default,
  itemListOrder: validSortOpts,
  type: (0, _eq3.default)(_const.COLLECTION_TYPE),
  title: _isString3.default
});
var validStatusOpts = exports.validStatusOpts = (0, _partial3.default)(_includes3.default, [_const.CREATED, _const.CONFIRMED]);
var isListItem = exports.isListItem = (0, _conforms3.default)({
  actionStatus: validStatusOpts,
  startTime: _isNumber3.default,
  type: (0, _eq3.default)(_const.LIST_ITEM),
  position: _isNumber3.default,
  dateCreated: _isNumber3.default,
  id: _isString3.default
});

var isActionEnded = exports.isActionEnded = (0, _matchesProperty3.default)('actionStatus', _const.ENDED);

var getItemRef = exports.getItemRef = (0, _ary3.default)((0, _partialRight3.default)(_reduxGraph.getRef, 'item'), 1);
// Valid unless ended/removed.
var isValidListItem = exports.isValidListItem = (0, _overEvery3.default)((0, _negate3.default)(isActionEnded), getItemRef);
// Is the CollectionList the default favorite one?
var isFavList = exports.isFavList = (0, _matchesProperty3.default)('title', _const.FAV_TITLE);


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/lib/lang.js
// module id = 231
// module chunks = 0